module.exports = __webpack_public_path__ + "img/success.9184d422.svg";